import axios from 'axios';

export const saveReferrer = (referrerBody, referrerHeaders) => {
    return axios.post('/api/referrers', referrerBody, referrerHeaders);
};